// import { saveMessage } from '../actions/';

const initialState = {
  clientId: 6,
  clients: [
    {
      key: 6,
      text: "Life Church"
    },
    {
      key: 7,
      text: "McAfee Taft"
    }
  ]
}

const client = (state = initialState, action) => {
   switch (action.type) {

    case 'SAVE_MESSAGE':
      return Object.assign({}, state, {
        visibilityFilter: action.filter
      })

      
    default:
      return state;
  }
  
}

export default client



// WEBPACK FOOTER //
// ./src/reducers/client.js